import { useCallback, useMemo } from 'react';

export const useUnitsAfterState = (formik) => {
  const unitsAfter = useMemo(() => {
    const units =
      Math.abs(formik.values.units) * Math.sign(formik.values.splitNumerator - formik.values.splitDenominator);
    const result =
      formik.values.splitDenominator === formik.values.splitNumerator
        ? units
        : units / (1 - formik.values.splitDenominator / formik.values.splitNumerator);
    return !result || Number.isNaN(result) ? '' : result;
  }, [formik.values.units, formik.values.splitNumerator, formik.values.splitDenominator]);

  const setUnitsAfter = useCallback(
    (newUnitsAfter) => {
      if (newUnitsAfter !== unitsAfter) {
        const units = newUnitsAfter * (1 - formik.values.splitDenominator / formik.values.splitNumerator);
        if (!Number.isNaN(units) && units !== formik.values.units) {
          formik.setFieldValue('units', units);
        }
      }
    },
    [unitsAfter, formik],
  );

  return [unitsAfter, setUnitsAfter];
};

export default useUnitsAfterState;
